{
    "Title": "Gestisci code",
    "ManageQueuesDescriptionTitle": "Descrizione",
    "ManageQueuesCQConfigurationsTitle": "Configurazioni CQ",
    "ManageQueuesResourceAccountsTitle": "Conti delle risorse",
    "ManageQueuesMonitoringStatusTitle": "Stato di monitoraggio",
    "ManageQueueFiltersTitle": "Filtri",
    "ManageQueueCallMonitoringHistoric": "Storico",
    "ManageQueueCallMonitoringRealTime": "In tempo reale",
    "ManageQueueCallMonitoringRealTimeForced": "In tempo reale (forzato)",
    "ManageQueueCallMonitoringUnknown": "Sconosciuto",
    "ManageQueueCallCQConfigurationCompatible": "Compatibile",
    "ManageQueueCallCQConfigurationIncompatible": "Incompatibile",
    "ManageQueuesQueueFilterAll": "Tutte le code",
    "ManageQueuesFilterCompatible": "Code compatibili",
    "ManageQueuesFilterIncompatible": "Code incompatibili",
    "ManageQueue_DisableEnableRealtime_Confirm": "Confermare",
    "ManageQueue_DisableEnableRealtime_Cancel": "Cancellare",
    "ManageQueue_MonitorAllMessage": "Vuoi davvero abilitare il monitoraggio in tempo reale per tutte le code?",
    "ManageQueue_UnmonitorAllMessage": "Vuoi davvero disattivare il monitoraggio in tempo reale per tutte le code?",
    "ManageQueue_Loading_Monitoring_All": "Abilitazione del monitoraggio in tempo reale per tutte le code",
    "ManageQueue_Loading_Unmonitoring_All": "Disabilitare il monitoraggio in tempo reale per tutte le code",
    "ManageQueue_Pending_Queue_Disabling": "Disattivazione del monitoraggio...",
    "ManageQueue_Pending_Queue_Enabling": "Abilitazione del monitoraggio...",
    "ManageQueue_Disable_RT_Popper": "Disabilita il monitoraggio in tempo reale su tutte le code",
    "ManageQueue_Enable_RT_Popper": "Abilita il monitoraggio in tempo reale su tutte le code",
    "ManageQueues_Not_Found_Error": "Non sono state trovate code corrispondenti a quella ricerca",
    "NAME": "ManageQueues"
}